const newSideNav = {
  home: "Home",
  patients: "Patients",
  labs: "Labs",
  catalog: "Catalog",
  orders: "Orders",
  products: "Products",
  analytics: "Analytics",
  myTools: "My tools",
  templates: "Templates",
  multiPatientPlans: "Multi-{{patientTerm}} plans",
  resources: "Resources",
  shopWholesale: "Shop wholesale",
  labKits: "Lab kits",
  settings: "Settings",
  fsAssist: "FS Assist",
  stopImpersonating: "Stop impersonating",
} as any;

export { newSideNav };
